import React, { useState, useEffect, useRef } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaLinkedin, FaTwitter, FaFacebook, FaInstagram, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';

const CONTACT_INFO = [
    { icon: <FaMapMarkerAlt />, label: 'Address', value: '15 Charlotte Street, Freetown, Sierra Leone' },
    { icon: <FaEnvelope />,     label: 'Email',   value: 'info@connectallsl.com', href: 'mailto:info@connectallsl.com' },
    { icon: <FaPhone />,        label: 'Phone',   value: '+232 76 000 000',        href: 'tel:+23276000000' },
];

const SOCIALS = [
    { icon: <FaLinkedin />,  href: '#' },
    { icon: <FaTwitter />,   href: '#' },
    { icon: <FaFacebook />,  href: '#' },
    { icon: <FaInstagram />, href: '#' },
];

const SUBJECTS = [
    'Business Strategy Consulting',
    'Technology Solutions',
    'Financial Advisory',
    'Project Management',
    'Training & Capacity',
    'Government Advisory',
    'General Enquiry',
];

function Contact() {
    const sectionRef = useRef(null);
    const [form, setForm]       = useState({ firstName: '', lastName: '', email: '', subject: '', message: '' });
    const [sending, setSending] = useState(false);
    const [sent, setSent]       = useState(false);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;
        const targets = el.querySelectorAll('.fade-up');
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }),
            { threshold: 0.08 }
        );
        targets.forEach(t => observer.observe(t));
        return () => observer.disconnect();
    }, []);

    const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = (e) => {
        e.preventDefault();
        setSending(true);
        // Simulate network delay; replace with real API call
        setTimeout(() => { setSending(false); setSent(true); }, 1800);
    };

    return (
        <section id="contact" className="section section-alt" ref={sectionRef}>
            <div className="text-center fade-up" style={{ maxWidth: 'var(--max-w)', margin: '0 auto' }}>
                <p className="section-label">Get In Touch</p>
                <h2 className="section-title">
                    Let's Start a <span className="gradient-text">Conversation</span>
                </h2>
                <p className="section-subtitle">
                    Ready to take your business to the next level? Reach out and one of our
                    consultants will respond within 24 hours.
                </p>
            </div>

            <div className="contact-wrap">
                {/* Info column */}
                <div className="contact-info">
                    {CONTACT_INFO.map((item, i) => (
                        <div key={i} className={`contact-info-item fade-up delay-${i + 1}`}>
                            <div className="contact-info-icon">{item.icon}</div>
                            <div className="contact-info-text">
                                <h4>{item.label}</h4>
                                {item.href
                                    ? <a href={item.href}>{item.value}</a>
                                    : <p>{item.value}</p>
                                }
                            </div>
                        </div>
                    ))}

                    <div className={`contact-social fade-up delay-4`}>
                        <h4>Follow Us</h4>
                        <div className="social-icons">
                            {SOCIALS.map((s, i) => (
                                <a key={i} href={s.href} className="social-icon" target="_blank" rel="noreferrer">
                                    {s.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Form column */}
                <div className="contact-form fade-up delay-2">
                    {sent ? (
                        <div className="form-success">
                            <div className="form-success-icon"><FaCheckCircle /></div>
                            <h3>Message Sent!</h3>
                            <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="firstName">First Name</label>
                                    <input id="firstName" name="firstName" type="text" placeholder="John" required value={form.firstName} onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="lastName">Last Name</label>
                                    <input id="lastName" name="lastName" type="text" placeholder="Smith" required value={form.lastName} onChange={handleChange} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input id="email" name="email" type="email" placeholder="john@company.com" required value={form.email} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="subject">Service of Interest</label>
                                <select id="subject" name="subject" required value={form.subject} onChange={handleChange}>
                                    <option value="" disabled>Select a service…</option>
                                    {SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea id="message" name="message" rows={5} placeholder="Tell us about your project…" required value={form.message} onChange={handleChange} />
                            </div>

                            <button type="submit" className="form-submit" disabled={sending}>
                                {sending ? 'Sending…' : <><FaPaperPlane /> Send Message</>}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
}

export default Contact;

